exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice{height:40px;height:2.5rem}.invoice+.invoice{border-top:2px solid rgba(0,0,0,.5);border-top:.125rem solid rgba(0,0,0,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16bc798a","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/account-invoices-modal/style.scss
// module id = 236
// module chunks = 0